import { render, staticRenderFns } from "./LibrarySubcategories.vue?vue&type=template&id=495f2ba6&"
import script from "./LibrarySubcategories.vue?vue&type=script&lang=ts&"
export * from "./LibrarySubcategories.vue?vue&type=script&lang=ts&"
import style0 from "./LibrarySubcategories.vue?vue&type=style&index=0&id=495f2ba6&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports